<template>
    <section>
        <div class="modal-card" style="width: 65vw; height:70vh">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ __('strings.discount.add_new_discount') }}</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('toggleAddDiscountModal')"/>
            </header>
            <section class="modal-card-body">
                <b-field horizontal :label="__('strings.discount.name')">
                    <b-input v-model="inputs.name" type="text"></b-input>
                </b-field>
                <b-field horizontal :label="__('strings.discount.number_of_products')">
                    <p>
                        {{ products.length }}
                    </p>
                </b-field>
                <b-field horizontal :label="__('strings.discount.range_date')">
                    <div class="columns is-align-items-center">
                        <div class="column is-5">
                            <b-datetimepicker
                                rounded
                                v-model="date.start_date"
                                :date-parser="(d) => {moment(d, dateFormat).ISO}"
                                placeholder="Click to select..."
                                icon="calendar-today"
                                :locale="locale"
                                horizontal-time-picker
                                @input="handleOnChangeStartDate" :min-datetime="now">
                            </b-datetimepicker>
                        </div>
                        <div class="column is-5">
                            <b-datetimepicker
                                rounded
                                v-model="date.end_date"
                                :date-parser="(d) => {moment(d, dateFormat)}"
                                placeholder="Click to select..."
                                icon="calendar-today"
                                :locale="locale"
                                horizontal-time-picker
                                @input="handleOnChangeEndDate"  :min-datetime="tomorrow">
                            </b-datetimepicker>
                        </div>
                        <div class="column is-1">
                            {{ `${deltaDays} GIORNI` }}
                        </div>
                    </div>

                </b-field>
                <b-field horizontal label="Website">
                    <b-dropdown class="filter-dropdown"
                                multiple
                                scrollable
                                v-model="inputs.website_ids"
                                expanded>
                        <button class="button is-primary" type="button" slot="trigger">
                            <span>{{ __('strings.product.selected_f') }} ({{ inputs.website_ids.length }})</span>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="website in websites"
                            :value="website.id"
                            :key="website.id+website.name"
                            aria-role="listitem">
                            <span>{{ website.name }}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-field>

                <b-field horizontal :label="__('strings.discount.discount_value')">
                    <div class="columns is-align-items-center">
                        <div class="column is-one-fifth">
                            <b-input
                                v-model="inputs.discount"
                                type="number"
                                min="0"
                                max="100">
                            </b-input>
                        </div>
                        <div class="column">
                            %
                        </div>
                    </div>
                </b-field>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" type="button" @click="$emit('toggleAddDiscountModal')">
                    {{ __('strings.discount.cancel') }}
                </button>
                <button
                    class="button is-primary"
                    :disabled="products.length === 0 || (date.cm_start_date >= date.cm_end_date) || inputs.discount === 0 || !inputs.name "
                    @click="handleOnClickSubmit">
                    {{ __('strings.discount.submit') }}
                </button>
            </footer>
        </div>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        products: {
            required: true,
            type: Array
        },
        websites: {
            required: true,
            type: Array
        },
        retailers: {
            required: true,
            type: Array
        },
    },
    data() {
        return {
            dateFormat: "YYYY-MM-DD HH:mm:ss",
            locale: moment.locale(),
            deltaDays: 0,
            currentRetailers: [],
            inputs: {
                product_ids: [],
                discount: 0,
                retailer_id: 1,
                website_ids: [],
                name: undefined,
                start_date: undefined,
                end_date: undefined,
            },
            date: {
                start_date: new Date(),
                end_date: new Date(),
                cm_start_date: moment().valueOf(),
                cm_end_date: moment().valueOf(),
            }
        }
    },
    mounted() {
        this.inputs.product_ids = this.products;
        this.currentRetailers = this.retailers.slice(1);
        this.inputs.start_date = moment.utc().format(this.dateFormat);
        this.inputs.end_date = moment.utc().format(this.dateFormat);

        this.date.start_date = this.now;
        this.date.end_date = this.tomorrow;
    },
    destroyed() {
        this.inputs = {
            product_ids: [],
            discount: 0,
            retailer_id: 1,
            website_ids: [],
            name: undefined,
            start_date: undefined,
            end_date: undefined,
        }
    },
    methods: {
        moment: function () {
            return moment();
        },
        handleOnChangeStartDate(value) {
            this.date.start_date = value;
            this.inputs.start_date = moment.utc(value).format(this.dateFormat);
            this.date.cm_start_date = moment(value).valueOf();
            this.updateDeltaDays();
        },
        handleOnChangeEndDate(value) {
            this.date.end_date = value;
            this.inputs.end_date = moment.utc(value).format(this.dateFormat);
            this.date.cm_end_date = moment(value).valueOf();
            this.updateDeltaDays();
        },
        updateDeltaDays() {
            if (this.date.cm_start_date < this.date.cm_end_date) {
                this.deltaDays = moment(this.date.end_date).diff(moment(this.date.start_date), 'days');
            } else {
                this.deltaDays = 0;
            }
        },
        handleOnClickSubmit() {
            this.$emit('handleAddNewDiscountSubmit', this.inputs);
            this.$emit('toggleAddDiscountModal');
        }
    },
    computed: {
        now() {
            return new Date();
        },
        tomorrow() {
            let date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        }
    }
}
</script>
